import React from "react";
import PropTypes from "prop-types";

const NestedList = ({ data, path = "root" }) => {
  if (data === null || typeof data !== "object") {
    return <>{String(data)}</>;
  }

  // arrays → index‑based recursion
  if (Array.isArray(data)) {
    return (
      <ul>
        {data.map((item, idx) => (
          <li key={`${path}-${idx}`}>
            <NestedList data={item} path={`${path}-${idx}`} />
          </li>
        ))}
      </ul>
    );
  }

  // objects → key/value recursion
  return (
    <ul>
      {Object.entries(data).map(([key, value]) => (
        <li key={`${path}-${key}`}>
          <strong>{key}:</strong>
          {typeof value === "object" ? (
            <NestedList data={value} path={`${path}-${key}`} />
          ) : (
            String(value)
          )}
        </li>
      ))}
    </ul>
  );
};
NestedList.propTypes = {
  data: PropTypes.any.isRequired,
  path: PropTypes.string
};
export default NestedList;
